import { localeHasDocs } from '~/utils/docs-manifest';
import { helpIndexPath } from '~/utils/help-index';

// A direct load of /help runs this middleware outside a component setup, where useI18n() throws.
// The i18n instance of the Nuxt app works in both cases.
export default defineNuxtRouteMiddleware(() => {
  const locale = useNuxtApp().$i18n.locale.value;
  return navigateTo(helpIndexPath(locale, localeHasDocs), { replace: true });
});
